module.exports = __webpack_public_path__ + "images/paylocity_icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/paylocity_icon.png
// module id = 816
// module chunks = 0